<template>
  <div>
    <div class="footer">
      <div class="footer-container">
        <span class="text1">友情链接</span>
        <ul class="footer-nav">
          <div v-for="(item,index) in floorList" :key="index">
            <li>
              <a :href="item.forwardUrl" rel="noopenner noreferrer" target="_blank" class="footer-nav-item">{{item.title}}</a>
            </li>
          </div>
        </ul>
        <ul class="footer-nav mt">
          <li>电子邮件：gzzjxhy@126.com</li>
          <li>电话：020-81602823</li>
          <li>地址：广州市荔湾区光复中路403号第三层</li>
        </ul>
        <div class="footer-foot">
          <span><a href="https://beian.miit.gov.cn" target="_blank" style="color:#fff">粤ICP备2023156288号-1</a></span>
          <span><a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" style="color:#fff">粤公网安备44010402003400号</a></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  //给组件起一个名字,开发者工具中显示这个组件的时候，显示的就是这个名字
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Footer",
  computed: {
    ...mapState({
      floorList: state => state.home.floorList //对象简写形式
    })
  },
  data() {
    return {
      // footerList: [
      //   {
      //     title: "广东市教育局",
      //     forwardUrl: "https://www.baidu.com"
      //   },
      //   {
      //     title: "广东市教育局",
      //     forwardUrl: "https://www.baidu.com"
      //   },
      //   {
      //     title: "广东市教育局",
      //     forwardUrl: "https://www.baidu.com"
      //   },
      //   {
      //     title: "广东市教育局",
      //     forwardUrl: "https://www.baidu.com"
      //   },
      //   {
      //     title: "广东市教育局",
      //     forwardUrl: "https://www.baidu.com"
      //   }
      // ]
    };
  }
};
</script>

<style scoped lang="less">
.mt {
  margin-top: 30px !important;
  li {
    margin-left: 40px !important;
  }
}
.footer {
  background-color: #47a1d1;
  width: 100%;
  margin: 0 auto;
  .footer-container {
    background-color: #47a1d1;
    width: 1200px;
    // height: 180px;
    margin: 0 auto;
    padding: 40px 0px;
    .text1 {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .footer-nav {
      margin-top: 16px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      li {
        margin-left: 30px;
        color: #fff;
      }
      a {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 20px;
      }
    }
    .footer-foot {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      span {
        margin-left: 10px;
      }
    }
  }
}
@media only screen and (min-width: 993px) {
  .mt {
    margin-top: 30px !important;
    li {
      margin-left: 40px !important;
    }
  }
  .footer {
    background-color: #47a1d1;
    width: 100%;
    margin: 0 auto;
    .footer-container {
      background-color: #47a1d1;
      width: 1200px;
      // height: 180px;
      margin: 0 auto;
      padding: 40px 0px;
      .text1 {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .footer-nav {
        margin-top: 16px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        li {
          margin-left: 30px;
          color: #fff;
        }
        a {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 20px;
        }
      }
      .footer-foot {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>
